import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
export function logUserAction(isCompose, action, item) {
    // The item will be null if rendered as a fabric button on the surface.
    var actionSource = 'Pinned';
    if (item && item.renderedInOverflow) {
        // If the item is rendered in the overflow, it either wasn't pinned to begin with or
        // was moved to the overflow due to limited space.
        if (item.isPinned) {
            actionSource = 'Overflow';
        }
        else {
            actionSource = 'NotPinned';
        }
    }
    // Break up data points to stay under 24 unique values per key.
    if (isCompose) {
        var _a = datapoints.CSACountComposeUserAction.datapoint, name_1 = _a.name, customData = _a.customData;
        logUsage(name_1, customData(action, actionSource));
    }
    else {
        var _b = datapoints.CSACountReadUserAction.datapoint, name_2 = _b.name, customData = _b.customData;
        logUsage(name_2, customData(action, actionSource));
    }
}
export function onCommandBarDataReduced(movedItem) {
    if (movedItem.subMenuProps) {
        // Mark each subMenu item as rendered in overflow for telemetry.
        movedItem.subMenuProps.items.forEach(function (subItem) {
            subItem.renderedInOverflow = true;
        });
    }
}
export function onCommandBarDataGrown(movedItem) {
    if (movedItem.subMenuProps) {
        // Mark each subMenu item as not rendered in overflow for telemetry.
        movedItem.subMenuProps.items.forEach(function (subItem) {
            subItem.renderedInOverflow = false;
        });
    }
}
//# sourceMappingURL=telemetryUtils.js.map